import { render, staticRenderFns } from "./main-layout-horizontal.vue?vue&type=template&id=3fe17100&scoped=true"
import script from "./main-layout-horizontal.vue?vue&type=script&lang=js"
export * from "./main-layout-horizontal.vue?vue&type=script&lang=js"
import style0 from "./main-layout-horizontal.vue?vue&type=style&index=0&id=3fe17100&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe17100",
  null
  
)

export default component.exports